import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Button, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@mui/material';
import SyncOutlinedIcon from '@mui/icons-material/SyncOutlined';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import SearchOutlinedIcon from '@mui/icons-material/SearchOutlined';
import SettingsOutlinedIcon from '@mui/icons-material/SettingsOutlined';
import KeyboardArrowRightIcon from '@mui/icons-material/KeyboardArrowRight';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import AccessTimeOutlinedIcon from '@mui/icons-material/AccessTimeOutlined';
import LockOutlinedIcon from '@mui/icons-material/LockOutlined';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import BarChartOutlinedIcon from '@mui/icons-material/BarChartOutlined';
import PieChartOutlineIcon from '@mui/icons-material/PieChartOutline';
import StorefrontOutlinedIcon from '@mui/icons-material/StorefrontOutlined';
import WarningAmberOutlinedIcon from '@mui/icons-material/WarningAmberOutlined';
import TrendingUpIcon from '@mui/icons-material/TrendingUp';
import TrendingDownIcon from '@mui/icons-material/TrendingDown';
import TrendingFlatIcon from '@mui/icons-material/TrendingFlat';
import HelpOutlineIcon from '@mui/icons-material/HelpOutline';
import ShowChartIcon from '@mui/icons-material/ShowChart';
import PersonOutlineIcon from '@mui/icons-material/PersonOutline';
import CheckBoxIcon from '@mui/icons-material/CheckBox';
import AdjustIcon from '@mui/icons-material/Adjust';
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';
import VisibilityOutlinedIcon from '@mui/icons-material/VisibilityOutlined';
import AutorenewIcon from '@mui/icons-material/Autorenew';
import ManageAccountsOutlinedIcon from '@mui/icons-material/ManageAccountsOutlined';
import DashboardCustomizeOutlinedIcon from '@mui/icons-material/DashboardCustomizeOutlined';
import ImportContactsOutlinedIcon from '@mui/icons-material/ImportContactsOutlined';
import DoneIcon from '@mui/icons-material/Done';
import InsertDriveFileOutlinedIcon from '@mui/icons-material/InsertDriveFileOutlined';

const complianceAlertsData = [
    { admin: 'Dr. Shaunak', action: 'Blocked', alias: 'API Connection Path ID8920', time: '11:55 AM', actionColor: '#DDA057', actionBg: '#FEF4ED' },
    { admin: 'Zakaria', action: 'Masked', alias: 'PII Bpm/lhr Data Hindi Script', time: '11:05 AM', actionColor: '#2A818F', actionBg: '#E9F2F3' },
    { admin: 'Farouk', action: 'Restricted', alias: 'Upstream Drift is Someother log', time: '10:45 AM', actionColor: '#888', actionBg: '#F5F5F5' },
];
const AISubscriptionUsage = () => {
    const navigate = useNavigate();

    return (
        <>
            <div className="main_title">
                <h1>AI Subscription & Usage Policy Control</h1>
                <p>
                    <button onClick={() => navigate("/dashboard")}>Dashboard</button> - AI Subscription & Usage Policy Control
                </p>
            </div>
            <div className="table_flex">
                <div className="lt">
                    {/* Monthly AI Usage Summary */}
                    <div className="monthly_ai_usage_card">
                        <div className="card_header">
                            <h2>Monthly AI Usage Summary</h2>
                       
                        </div>
                        <div className="card_body">
                            {/* Donut Chart Section */}
                            <div className="donut_section">
                                <div className="donut_wrapper">
                                    <svg width="100" height="100" viewBox="0 0 100 100">
                                        <circle cx="50" cy="50" r="40" fill="none" stroke="#E8EBF2" strokeWidth="12" />
                                        <circle cx="50" cy="50" r="40" fill="none" stroke="#DDA057" strokeWidth="12" strokeDasharray="113 251.2" strokeDashoffset="0" strokeLinecap="round" />
                                        <circle cx="50" cy="50" r="40" fill="none" stroke="#2A818F" strokeWidth="12" strokeDasharray="37.6 251.2" strokeDashoffset="-120" strokeLinecap="round" />
                                    </svg>
                                    <div className="donut_text">
                                        <strong>59%</strong>
                                        <span>Consumed</span>
                                    </div>
                                </div>
                            </div>

                            {/* Middle Info Section */}
                            <div className="middle_info_section">
                                <div className="tokens_count">
                                    <h3>2.37M / 4.0M <span className="light_text">Tokens</span></h3>
                                </div>
                                <ul className="info_list">
                                    <li>
                                        <PieChartOutlineIcon className="icon orange" />
                                        <strong>59%</strong> toll cap. per hour
                                    </li>
                                    <li>
                                        <StorefrontOutlinedIcon className="icon blue" />
                                        <span className="blue_text">72 high usage vendors</span>
                                    </li>
                                    <li>
                                        <WarningAmberOutlinedIcon className="icon black" />
                                        <strong>40.5%</strong> of total <span className="light_text">limit pending</span>
                                    </li>
                                </ul>
                            </div>

                            {/* Right Tiers Section */}
                            <div className="tiers_section">
                                <div className="tier_row">
                                    <div className="tier_name">Grow Tier</div>
                                    <div className="tier_stat orange"><TrendingUpIcon className="icon" /> 35%</div>
                                    <div className="tier_limit"><span className="icon_square"></span> 700K <span className="light_text">limit</span></div>
                                    <div className="tier_arrow"><TrendingFlatIcon className="icon teal" /> 52%</div>
                                </div>
                                <div className="tier_row">
                                    <div className="tier_name">Pro Tier</div>
                                    <div className="tier_stat orange"><TrendingDownIcon className="icon" /> 28%</div>
                                    <div className="tier_limit"><span className="icon_square"></span> 500K <span className="light_text">limit</span></div>
                                    <div className="tier_arrow"><TrendingFlatIcon className="icon teal" /> 48%</div>
                                </div>
                                <div className="tier_row">
                                    <div className="tier_name">Elite Custom</div>
                                    <div className="tier_stat empty"></div>
                                    <div className="tier_limit"><strong>40.5%</strong> <span className="light_text">of total</span></div>
                                    <div className="tier_arrow"><TrendingFlatIcon className="icon teal" /> 9355 <HelpOutlineIcon className="icon small" /></div>
                                </div>
                            </div>
                        </div>
                    </div>
                    {/* Subscription Usage Limits */}
                    <div className="subscription_usage_limits_card">
                        <div className="card_header">
                            <div className="header_left">
                                <h2>Subscription Usage Limits</h2>
                             
                            </div>
                        
                        </div>

                        <TableContainer className="limits_table">
                            <Table size="small">
                                <TableHead>
                                    <TableRow>
                                        <TableCell>Tier</TableCell>
                                        <TableCell>Model Cost Mode</TableCell>
                                        <TableCell>Throttling Rule (Reqs/Sec) <KeyboardArrowDownIcon sx={{ fontSize: 14, verticalAlign: 'middle', color: '#999' }} /></TableCell>
                                        <TableCell align="right"></TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    <TableRow>
                                        <TableCell className="tier_cell" style={{ fontWeight: 600 }}>Silver</TableCell>
                                        <TableCell className="quota_cell">12 / 70 <KeyboardArrowRightIcon sx={{ fontSize: 14, color: '#ccc', verticalAlign: 'middle', marginLeft: '8px' }} /></TableCell>
                                        <TableCell>
                                            <div className="throttling_status" style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                                                <span className="icon_circle green" style={{ width: '10px', height: '10px', borderRadius: '50%', backgroundColor: '#4CAF50', display: 'inline-block' }}></span> N/A
                                            </div>
                                        </TableCell>
                                        <TableCell align="right" style={{ color: '#999', fontSize: '13px' }}>
                                            N/A
                                        </TableCell>
                                    </TableRow>
                                    <TableRow>
                                        <TableCell className="tier_cell" style={{ fontWeight: 600 }}>Gold</TableCell>
                                        <TableCell className="quota_cell">1 / 500 <KeyboardArrowRightIcon sx={{ fontSize: 14, color: '#ccc', verticalAlign: 'middle', marginLeft: '8px' }} /></TableCell>
                                        <TableCell>
                                            <div className="throttling_status" style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                                                <span className="icon_circle green" style={{ width: '10px', height: '10px', borderRadius: '50%', backgroundColor: '#4CAF50', display: 'inline-block' }}></span> N/A
                                            </div>
                                        </TableCell>
                                        <TableCell align="right" style={{ color: '#999', fontSize: '13px' }}>
                                            N/A
                                        </TableCell>
                                    </TableRow>
                                    <TableRow>
                                        <TableCell className="tier_cell" style={{ fontWeight: 600 }}>Platinum</TableCell>
                                        <TableCell className="quota_cell">5 / 1500 <KeyboardArrowRightIcon sx={{ fontSize: 14, color: '#ccc', verticalAlign: 'middle', marginLeft: '8px' }} /></TableCell>
                                        <TableCell>
                                            <div className="throttling_status" style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                                                <span className="icon_circle green" style={{ width: '10px', height: '10px', borderRadius: '50%', backgroundColor: '#4CAF50', display: 'inline-block' }}></span> N/A
                                            </div>
                                        </TableCell>
                                        <TableCell align="right" style={{ color: '#999', fontSize: '13px' }}>
                                            N/A
                                        </TableCell>
                                    </TableRow>
                                    <TableRow>
                                        <TableCell className="tier_cell" style={{ fontWeight: 600 }}>Diamond</TableCell>
                                        <TableCell className="quota_cell">10 / 5000 <KeyboardArrowRightIcon sx={{ fontSize: 14, color: '#ccc', verticalAlign: 'middle', marginLeft: '8px' }} /></TableCell>
                                        <TableCell>
                                            <div className="throttling_status" style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                                                <span className="icon_circle green" style={{ width: '10px', height: '10px', borderRadius: '50%', backgroundColor: '#4CAF50', display: 'inline-block' }}></span> N/A
                                            </div>
                                        </TableCell>
                                        <TableCell align="right" style={{ color: '#999', fontSize: '13px' }}>
                                            N/A
                                        </TableCell>
                                    </TableRow>
                                </TableBody>
                            </Table>
                        </TableContainer>
                    </div>
                    {/* Feature Quotas by Tier */}
                    <div className="feature_quotas_card">
                        <div className="card_header">
                            <h2>Feature Quotas by Tier</h2>
                            <div className="legend_group">
                                <span className="legend_item"><span className="square yellow"></span> Low</span>
                                <span className="legend_item"><span className="square orange"></span> Warnings</span>
                                <span className="legend_item"><span className="square brown"></span> Critical</span>
                            </div>
                        </div>

                        <div className="quotas_flex">
                            <div className="lt_table">
                                <TableContainer>
                                    <Table size="small">
                                        <TableHead>
                                            <TableRow>
                                                <TableCell>Feature</TableCell>
                                                <TableCell>Scale</TableCell>
                                                <TableCell>Pro</TableCell>
                                                <TableCell>Elite +</TableCell>
                                                <TableCell>Custom</TableCell>
                                            </TableRow>
                                        </TableHead>
                                        <TableBody>
                                            <TableRow>
                                                <TableCell className="feature_name">Smart Pricing</TableCell>
                                                <TableCell><div className="val_cell">200 <HelpOutlineIcon className="icon" /></div></TableCell>
                                                <TableCell><div className="val_cell">1,000K <HelpOutlineIcon className="icon" style={{ visibility: 'hidden' }} /></div></TableCell>
                                                <TableCell><div className="val_cell">1200 <HelpOutlineIcon className="icon" /></div></TableCell>
                                                <TableCell>
                                                    <div className="retry_btn">
                                                        <AutorenewIcon className="icon orange" /> Retry <KeyboardArrowDownIcon sx={{ fontSize: 14, color: '#999' }} />
                                                    </div>
                                                </TableCell>
                                            </TableRow>
                                            <TableRow>
                                                <TableCell className="feature_name">Recommendation</TableCell>
                                                <TableCell><div className="val_cell">100 <HelpOutlineIcon className="icon" /></div></TableCell>
                                                <TableCell><div className="val_cell">1,200K <HelpOutlineIcon className="icon" style={{ visibility: 'hidden' }} /></div></TableCell>
                                                <TableCell><div className="val_cell">1850 <HelpOutlineIcon className="icon" /></div></TableCell>
                                                <TableCell>
                                                    <div className="retry_btn">
                                                        <AutorenewIcon className="icon orange" /> Retry <KeyboardArrowDownIcon sx={{ fontSize: 14, color: '#999' }} />
                                                    </div>
                                                </TableCell>
                                            </TableRow>
                                            <TableRow>
                                                <TableCell className="feature_name">Vendor Growth Planner</TableCell>
                                                <TableCell><div className="val_cell"><HelpOutlineIcon className="icon" /> 20,250</div></TableCell>
                                                <TableCell><div className="val_cell">180K <HelpOutlineIcon className="icon" /></div></TableCell>
                                                <TableCell><div className="val_cell"><HelpOutlineIcon className="icon" style={{ visibility: 'hidden' }} /> </div></TableCell>
                                                <TableCell>
                                                    <div className="retry_btn">
                                                        <AutorenewIcon className="icon orange" /> Retry <KeyboardArrowDownIcon sx={{ fontSize: 14, color: '#999' }} />
                                                    </div>
                                                </TableCell>
                                            </TableRow>
                                            <TableRow>
                                                <TableCell className="feature_name">Campaign Optimization</TableCell>
                                                <TableCell><div className="val_cell"><HelpOutlineIcon className="icon" /> 20,000</div></TableCell>
                                                <TableCell><div className="val_cell">200K <HelpOutlineIcon className="icon" /></div></TableCell>
                                                <TableCell><div className="val_cell"><HelpOutlineIcon className="icon" style={{ visibility: 'hidden' }} /> </div></TableCell>
                                                <TableCell>
                                                    <div className="retry_btn">
                                                        <AutorenewIcon className="icon orange" /> Retry <KeyboardArrowDownIcon sx={{ fontSize: 14, color: '#999' }} />
                                                    </div>
                                                </TableCell>
                                            </TableRow>
                                            <TableRow>
                                                <TableCell className="feature_name">Dispute AI</TableCell>
                                                <TableCell><div className="val_cell">200 <HelpOutlineIcon className="icon" /></div></TableCell>
                                                <TableCell><div className="val_cell">30,000 <HelpOutlineIcon className="icon" style={{ visibility: 'hidden' }} /></div></TableCell>
                                                <TableCell><div className="val_cell">230K <HelpOutlineIcon className="icon" /></div></TableCell>
                                                <TableCell>
                                                    <div className="retry_btn">
                                                        <AutorenewIcon className="icon orange" /> Retry <KeyboardArrowDownIcon sx={{ fontSize: 14, color: '#999' }} />
                                                    </div>
                                                </TableCell>
                                            </TableRow>
                                        </TableBody>
                                    </Table>
                                </TableContainer>
                            </div>

                            <div className="rt_chart_card">
                                <div className="bar_chart_area">
                                    <svg width="100%" height="80" viewBox="0 0 200 80">
                                        <rect x="20" y="20" width="12" height="60" fill="#E2E8F0" rx="2" />
                                        <rect x="50" y="40" width="12" height="40" fill="#CBD5E0" rx="2" />
                                        <rect x="80" y="45" width="12" height="35" fill="#CBD5E0" rx="2" />
                                        <rect x="110" y="55" width="12" height="25" fill="#E2E8F0" rx="2" />
                                        <rect x="140" y="30" width="12" height="50" fill="#DDA057" rx="2" />
                                        <rect x="170" y="10" width="12" height="70" fill="#DC5E45" rx="2" />

                                        {/* X-axis labels roughly placed */}
                                        <text x="26" y="95" fontSize="8" fill="#999" textAnchor="middle">Free</text>
                                        <text x="56" y="95" fontSize="8" fill="#999" textAnchor="middle">Scale</text>
                                        <text x="86" y="95" fontSize="8" fill="#999" textAnchor="middle">Grow</text>
                                        <text x="116" y="95" fontSize="8" fill="#999" textAnchor="middle">Pro</text>
                                        <text x="146" y="95" fontSize="8" fill="#999" textAnchor="middle">Custom</text>
                                        <text x="176" y="95" fontSize="8" fill="#999" textAnchor="middle">Quota+</text>
                                    </svg>
                                </div>
                                <div className="stats_block">
                                    <div className="title"><AddCircleOutlineIcon className="icon" /> Voided Operations</div>
                                    <div className="val">
                                        2.377M <span className="light_text">Tokens Used</span> <KeyboardArrowRightIcon className="icon" />
                                    </div>
                                </div>
                                <div className="stats_block_last">
                                    <div className="title"><AutorenewIcon className="icon" /> High Confidence</div>
                                    <div className="val">
                                        72 <span className="light_text">Hot Vendors</span>
                                        <svg className="sparkline" viewBox="0 0 50 20">
                                            <path d="M0,15 L10,5 L20,10 L30,5 L40,15 L50,8" />
                                            <circle cx="50" cy="8" r="2" fill="#999" />
                                        </svg>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="rt">
                    {/* Access Rules & Optimization Settings */}
                    <div className="ai_sidebar_card">
                        <h3>Access Rules & Optimization Settings</h3>

                        <div className="setting_row">
                            <div className="setting_label">
                                <ImportContactsOutlinedIcon className="icon orange" /> Cache First Mode
                            </div>
                            <div className="setting_action">
                                <div className="toggle_switch"></div>
                            </div>
                        </div>

                        <div className="setting_row">
                            <div className="setting_label">
                                <AccessTimeOutlinedIcon className="icon orange" /> Monthly AI Cost Budget
                            </div>
                            <div className="setting_action">
                                <div className="select_box">
                                    AED 18,900 <KeyboardArrowDownIcon className="icon" />
                                </div>
                            </div>
                        </div>

                    </div>

                    {/* Feature Quotas by Tier (Sidebar list) */}
                    {/* <div className="ai_sidebar_card">
                        <h3>Feature Quotas by Tier</h3>

                        <div className="quota_list">
                            <div className="quota_item">
                                <div className="feature">
                                    <span className="icon_circle"><DoneIcon /></span> Smart Pricing
                                </div>
                                <div className="limit">
                                    <strong>100</strong> Reqs Per Second
                                </div>
                            </div>

                            <div className="quota_item">
                                <div className="feature">
                                    <span className="icon_circle"><DoneIcon /></span> Recommendations AI
                                </div>
                                <div className="limit">
                                    <strong>100</strong> tokens
                                </div>
                            </div>

                            <div className="quota_item">
                                <div className="feature">
                                    <span className="icon_circle"><DoneIcon /></span> Vendor Growth Planner
                                </div>
                                <div className="limit">
                                    <strong>30</strong> req/ss
                                </div>
                            </div>

                            <div className="quota_item">
                                <div className="feature">
                                    <span className="icon_circle"><DoneIcon /></span> Campaign Optimization
                                </div>
                                <div className="limit">
                                    <strong>20</strong> Reqs Per Second
                                </div>
                            </div>
                        </div>

                        <div className="strategy_footer">
                            <div className="label">
                                <AutorenewIcon className="icon" /> Strategy Set
                            </div>
                            <div className="sub_label">
                                Reversible
                            </div>
                            <div className="controls">
                                <div className="points">
                                    <span className="icon_square orange"></span> <span className="icon_square blue"></span> 12
                                </div>
                                <div className="toggle_small"></div>
                                <div className="dot"></div>
                            </div>
                        </div>
                    </div>
                     */}
                    {/* Bottom Report Generation */}
                    {/* <div className="generate_report_card">
                        <div className="left_info">
                            <InsertDriveFileOutlinedIcon className="icon" /> Org Appendices Templates <KeyboardArrowRightIcon className="arrow" />
                        </div>
                        <div className="btn_gen_outline">
                            <InsertDriveFileOutlinedIcon className="icon" /> Generate Report
                        </div>
                    </div> */}

                    <div className="bottom_generate_btn_wrapper">
                        <button className="btn_generate_report">Generate Report</button>
                    </div>
                </div>
            </div>
        </>
    );
};

export default AISubscriptionUsage;
